import { Component, OnInit } from '@angular/core';
import {CustomHeaderComponent } from '../../component/custom-header/custom-header.component';
import { ActivatedRoute } from "@angular/router";
import { CommonService } from '../../shared/common';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {

  public title = "";
  constructor(private customHeader: CustomHeaderComponent, private route: ActivatedRoute,private commonService: CommonService,) {

  }
  ngOnInit() {
    this.commonService.assignGlobals();
    this.route.queryParams.subscribe(params => {
      this.title = params["Title"];
    });
  }
}
